<template>
  <div class="vd-gl-content">
    <a-row type="flex" class="vd-table-head">
      <a-col flex="auto" class="vd-table-name"> 地区列表</a-col>
      <a-col class="vd-table-tool">
        <a-button
          class="common-button"
          type="primary"
          icon="arrow-left"
          :disabled="level <= 0"
          @click="back"
        >
          上级
        </a-button>
        <a-button type="primary" icon="plus" @click="showModal">
          新建
        </a-button>
        <a-divider type="vertical" />
        <a-icon class="common-icon" type="reload" @click="nowLevel" />
      </a-col>
    </a-row>

    <a-table
      :data-source="tableData"
      :defaultExpandAllRows="true"
      :pagination="false"
      :loading="loading"
      row-key="id"
      size="small"
    >
      <a-table-column title="ID" data-index="id" />
      <a-table-column title="名称" data-index="name" />
      <a-table-column align="center" title="简称" data-index="code" />
      <a-table-column align="center" title="权重" data-index="weigh" />
      <a-table-column align="center" title="状态" data-index="status" />
      <a-table-column align="center" title="地区管理" v-if="level < 2">
        <template slot-scope="record">
          <span>
            <a-tag color="blue" style="cursor: pointer" @click="next(record)">
              <template v-if="level === 0">
                {{ record.name + ' - 地市管理' }}
              </template>
              <template v-else-if="level === 1">
                {{ record.name + ' - 学习中心管理' }}
              </template>
            </a-tag>
          </span>
        </template>
      </a-table-column>
    </a-table>
    <!--  对话框 modal 弹出层 -->
    <a-modal
      :visible="visible"
      okText="提交"
      cancelText="取消"
      @ok="add"
      @cancel="cancel"
      :title="modalType ? '新增' : '修改'"
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="上级" prop="pid">
          <a-tooltip title="输入地区名称进行查询">
            <a-cascader
              :options="selectMenu"
              :fieldNames="fieldNames"
              :changeOnSelect="true"
              v-model="selectPath"
              placeholder="请选择上级地区"
              @change="casChange"
            />
          </a-tooltip>
        </a-form-model-item>
        <a-form-model-item label="地区名称" prop="name">
          <a-input
            class="vd-input-s"
            v-model="form.name"
            placeholder="请输入地区名称"
          />
        </a-form-model-item>
        <a-form-model-item label="简称" prop="code">
          <a-input
            class="vd-input-s"
            v-model="form.code"
            placeholder="请输入地区简称"
          />
        </a-form-model-item>
        <a-form-model-item label="权重" prop="weight">
          <a-input-number
            v-model="form.weight"
            class="vd-input-xs"
            placeholder="请设置权重"
          />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-switch v-model="form.status" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { get_area, modify_area } from '@/api'
import { get_area_tree } from '@/api/auth'
export default {
  name: 'Area',
  data() {
    return {
      // modal
      confirmLoading: false,
      visible: false,
      modalType: false, // false 添加 true 修改
      switchStatus: true,
      // from
      form: {
        id: 0,
        pid: undefined,
        name: '',
        code: '',
        weight: 0,
        status: true,
      },
      selectPath: [],
      rules: {
        pid: [{ required: true, message: '请选择上级地区', trigger: 'blur' }],
        name: [
          { required: true, message: '请输入地区名称', trigger: 'blur' },
          { min: 1, max: 30, message: '地区名称长度1-30', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入地区拼音', trigger: 'blur' },
          { min: 1, max: 30, message: '拼音长度1-30', trigger: 'blur' },
        ],
        weight: [{ required: true, message: '请设置权重', trigger: 'blur' }],
        status: [{ required: true, message: '请设置权重', trigger: 'blur' }],
      },
      // data
      tableData: [],
      loading: {
        size: 'large',
        spinning: false,
      },
      selectMenu: [],
      fieldNames: { label: 'name', value: 'id', children: 'children' },
      lastItem: [], // 上级
      level: 0, // 层级
    }
  },
  created() {
    this.getTableData(0)
    // 获取地区下拉
    this.areaSelect()
  },
  methods: {
    // 展示模态框
    showModal() {
      this.visible = !this.visible
    },
    // 添加新地区
    add() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          modify_area(this.form).then((res) => {
            if (res['code'] === 1) {
              this.$message.success(res['msg'])
              this.visible = !this.visible
              this.nowLevel()
            } else {
              this.$message.warning(res['msg'])
            }
          })
        }
      })
    },
    // 取消添加modal
    cancel() {
      this.visible = false
      this.$refs.ruleForm.resetFields()
    },
    casChange(value) {
      if (this.$HelperUtil.isEmpty(value)) {
        this.form.pid = undefined
      } else {
        this.form.pid = value[value.length - 1]
      }
      this.form.pid = value[value.length - 1]
      console.log(this.form.pid)
      this.selectPath = value
    },
    changeSwitch(checked) {
      this.switchStatus = checked
    },
    changeMenu(key) {
      console.log(key)
    },
    back() {
      this.level--
      this.getTableData(this.lastItem[this.level]['pid'])
      this.lastItem.pop()
    },
    nowLevel() {
      if (this.$HelperUtil.isEmpty(this.lastItem)) {
        this.getTableData(0)
      } else {
        this.getTableData(this.lastItem[this.level - 1]['id'])
      }
    },
    next(record) {
      if (this.level >= 2) {
        return false
      }
      this.lastItem.push(record)
      this.getTableData(this.lastItem[this.level]['id'])
      this.level++
    },
    getTableData(pid) {
      get_area({ pid }).then((res) => {
        if (res['code'] === 1) {
          this.tableData = res['area_data']
        } else {
          this.$message.warning(res['msg'])
        }
      })
    },
    areaSelect() {
      get_area_tree().then((res) => {
        if (res['code'] === 1) {
          this.selectMenu = res['areaTree']
        } else {
          this.$message.warning(res['msg'])
        }
      })
    },
  },
}
</script>
<style scoped lang="less"></style>
